import { render, staticRenderFns } from "./monev_sekolah.vue?vue&type=template&id=7b991652&"
import script from "./monev_sekolah.vue?vue&type=script&lang=js&"
export * from "./monev_sekolah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports